import { startOfDay, endOfDay, formatISO } from 'date-fns'
import { toZonedTime, fromZonedTime } from 'date-fns-tz'

import config from '../config'

type Input = string | number | Date

export const filterToday = (timezone = config.defaultTimezone) =>
  filterSpecificDay(new Date(), timezone)

export const filterSpecificDay = (
  date: Input,
  timezone = config.defaultTimezone
) => filterBetweenDays(date, date, timezone)

export const filterBetweenDays = (
  startDate: Input,
  endDate: Input,
  timezone = config.defaultTimezone
) => {
  const zonedStart = toZonedTime(startDate || new Date(), timezone)
  const zonedEnd = toZonedTime(endDate || new Date(), timezone)

  const startUtc = fromZonedTime(startOfDay(zonedStart), timezone)
  const endUtc = fromZonedTime(endOfDay(zonedEnd), timezone)

  return {
    afterDateTime: formatISO(startUtc),
    beforeDateTime: formatISO(endUtc),
  }
}
